module.exports = __webpack_public_path__ + "img/pro_six_3.dc48f076.jpg";